export const effects = [
  'no_animation',
  'bounce_in',
  'swing_in',
  'fade_in',
  'rotate_in_a',
  'rotate_in_b',
  'zoom_in',
  'zoom_out',
  'light_speed_in',
  'back_in_down',
  'pan',
  'rise',
  'tilt_in',
  'neon',
  'stomp',
  'magic_block'
];

export const defaultAnimation = 'no_animation';

export const defaultPageDuration = 3000;
export const defaultInOutDuration = 1000;
